import {Person} from './types';

export const MockData: Person[] = [
  {
    id: 1,
    userId: 13550,
    firstName: 'Svein Are',
    lastName: 'Grønsund',
    mobileNo: '+4792056062',
    hasCar: false,
    avatarUrl:
      'https://s.gravatar.com/avatar/d0d5c7906a472231becfdba1fb5fe8ef?s=80',
  },
  {
    id: 2,
    userId: 17376,
    firstName: 'Kåre',
    lastName: 'Sivertsen',
    mobileNo: '+4792056063',
    hasCar: false,
    avatarUrl: 'https://www.w3schools.com/howto/img_avatar.png',
  },
  {
    id: 3,
    userId: 17451,
    firstName: 'Bengt',
    lastName: 'Gustavsen',
    mobileNo: '+4792056064',
    hasCar: true,
    avatarUrl:
      'https://guidanceandcounsellingui.org/images/testimonials/avatar2.png',
  },
  {
    id: 4,
    userId: 1,
    firstName: 'Kari',
    lastName: 'Zahr',
    mobileNo: '+4792056067',
    hasCar: false,
    avatarUrl: 'https://darresne.com/img/female-avatar.png',
  },
  {
    id: 8,
    userId: 4,
    firstName: 'Ole',
    lastName: 'Pedersen',
    mobileNo: '+4792056068',
    hasCar: false,
    avatarUrl:
      'https://icons.iconarchive.com/icons/dapino/people/256/orange-boy-icon.png',
  },
  {
    id: 9,
    userId: 5,
    firstName: 'Ann',
    lastName: 'Stevens',
    mobileNo: '+4792056069',
    hasCar: true,
    avatarUrl: 'https://www.skyewallet.in/images/admin_avatar.png',
  },
  {
    id: 10,
    userId: 6,
    firstName: undefined,
    lastName: undefined,
    mobileNo: '+4792056070',
    hasCar: true,
    avatarUrl: undefined,
  },
  {
    id: 11,
    userId: 7,
    firstName: 'Sverre',
    lastName: 'Furunes',
    mobileNo: '+4792056071',
    hasCar: true,
    avatarUrl:
      'https://storage.jewheart.com/content/users/avatars/3746/avatar_3746_500.jpg?1558628223',
  },
  {
    id: 12,
    userId: 8,
    firstName: 'Ali',
    lastName: 'Bombau',
    mobileNo: '+4792056072',
    hasCar: false,
    avatarUrl:
      'https://storage.jewheart.com/content/users/avatars/3383/avatar_3383_500.jpg?1558627204',
  },
  {
    id: 13,
    userId: 9,
    firstName: 'Z',
    lastName: 'Platon',
    mobileNo: '+4792056073',
    hasCar: false,
    avatarUrl:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQy1QKMwvvFRtE7kNDp0oyv8e5k39uBdPxbbg&usqp=CAU',
  },
];
